// extracted by mini-css-extract-plugin
var _1 = "ContactInfo__row--SuRdE";
var _2 = "ContactInfo__subscribeCheck--_VSY_ OfficeGeneral__textSizeC--AYnRF CoreGeneral__textSizeC--e8OEt";
export { _1 as "row", _2 as "subscribeCheck" }
